import { render, staticRenderFns } from "./DesktopTable.vue?vue&type=template&id=5185bf9c&scoped=true"
import script from "./DesktopTable.vue?vue&type=script&lang=js"
export * from "./DesktopTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185bf9c",
  null
  
)

export default component.exports